package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class ServerIdMapQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun lookup(server_id: String): Query<String> = LookupQuery(server_id) { cursor ->
    cursor.getString(0)!!
  }

  public fun remember(server_id: String, local_id: String) {
    driver.execute(-774_404_915,
        """INSERT OR IGNORE INTO server_id_map(server_id, local_id) VALUES (?, ?)""", 2) {
          bindString(0, server_id)
          bindString(1, local_id)
        }
    notifyQueries(-774_404_915) { emit ->
      emit("server_id_map")
    }
  }

  private inner class LookupQuery<out T : Any>(
    public val server_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("server_id_map", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("server_id_map", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_374_148_538,
        """SELECT local_id FROM server_id_map WHERE server_id = ?""", mapper, 1) {
      bindString(0, server_id)
    }

    override fun toString(): String = "ServerIdMap.sq:lookup"
  }
}
